import React from "react";
import { forwardRef } from "react";

const Search = forwardRef((props, ref) => {
    return (
      <div
        className="searchBox border"
        style={{ width: props.width ? props.width : "" }}
      >
        <div className="input-group">
          <div className="input-group-text">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                stroke="#202223"
                strokeOpacity="0.5"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M20.9999 21L16.6499 16.65"
                stroke="#202223"
                strokeOpacity="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </div>
          <input
            ref={ref}
            type={props.type}
            className="form-control ps-0"
            value={props.val}
            aria-label="Sizing example input"
            aria-describedby="inputGroup-sizing-sm"
            placeholder={props.placeholder}
            onChange={props.onChange}
          />
        </div>
      </div>
    );
  });

export default Search;
